import defaultReducer from "./defaultReducer";

const initialState = { open: false };

export default defaultReducer("CREATE_ASSET_MODAL", initialState);
